(function(runtime) {
    var _ = runtime.components.dependencies._;
    var Modernizr = runtime.components.dependencies.Modernizr;

    var constants = runtime.components.constants.merge({
        sliderSelector: '.ixp-component-slider-uislider',
        sliderValueSelector: '.ixp-component-slider-value',
        sliderHandleSelector: '.ui-slider-handle',

        css: {
            orientation: {
                horizontal: 'ixp-component-slider-value-horizontal',
                vertical: 'ixp-component-slider-value-vertical'
            },
            styles: {
                filled: 'ixp-component-slider-filled'
            },
            valueLocation: {
                none: 'ixp-component-slider-value-none',
                handle: 'ixp-component-slider-value-handle',
                above_handle: 'ixp-component-slider-value-above_handle',
                min: 'ixp-component-slider-value-min',
                max: 'ixp-component-slider-value-max'
            }
        },

        extensibility: {
            events: {
                valueChanged: ':value:changed',
                displayValueChanging: ':displayValue:changing'
            }
        }
    });

    runtime.components.registerExtensibility('ixp-slider', {
        commands: constants.extensibility.commands || {},
        events: constants.extensibility.events || {}
    });

    var statics = {
        cssClassesToPreserve: [
                constants.css.orientation.horizontal,
                constants.css.orientation.vertical,
                constants.css.valueLocation.none,
                constants.css.valueLocation.handle,
                constants.css.valueLocation.aboveHandle,
                constants.css.valueLocation.min,
                constants.css.valueLocation.max
        ],

        // remove commas, try to parse as float; if fails, use 'defaultVal' instead
        coerceToFloat: function(input, defaultVal) {
            var defaultValFloat = _.isString(input) ? parseFloat(input.replace(/,/g, '')) : input;
            return isNaN(defaultValFloat) ? defaultVal : defaultValFloat;
        },

        getScaffolding: function(scaffoldingKey, builder, options) {
            return {
                style: {
                    customClass: builder.getDefaultTheme('slider')
                }
            };
        },
        getRangeValue: function($el) {
            return $el.hasClass(constants.css.styles.filled) ? 'min' : false;
        }
    };

    return runtime.components.register('ixp-slider', runtime.components.InputComponentBase, {
        initialize: function(options) {
            this.$elSlider = this.$el.find(constants.sliderSelector);
            this.$elSliderValue = this.$el.find(constants.sliderValueSelector);

            var $thisEl = this.$el;

            var config = {
                range: statics.getRangeValue($thisEl),
                orientation: this.orientation,
                min: this.numberMin === '' ? 0 : this.numberMin,
                max: this.numberMax === '' ? 100 : this.numberMax,
                step: this.numberStep || 1,
                defaultValue: this.defaultValue
            };
            this.triggerExtensibility(constants.extensibility.all.events.initializing, config, { any: true });

            this.defaultValue = config.defaultValue;

            this.$elSlider.slider({
                                      range: config.range,
                                      orientation: config.orientation,
                                      min: config.min,
                                      max: config.max,
                                      step: config.step,
                                      create: _.bind(this._onSliderCreated, this)
                                  });
        },

        onDocumentReady: function() {
            this._positionValueDisplay();
            return true;
        },

        onListenToInputEvents: function() {
            this.$elSlider.on('resize' + this.eventNamespace, _.debounce(_.bind(this._positionValueDisplay, this), 100, { maxWait: 250 }));
            this.$elSlider.on('slidechange' + this.eventNamespace, _.bind(this._onSliderChange, this));
            this.$elSlider.on('slide' + this.eventNamespace, _.bind(this._onSliderSlide, this));
        },

        onListenToStudioEvents: function(events) {
            // TODO jhp 10/2014: we should only listen for a change on the slider's micro-theme -- not on all changes
            events.on('element:microtheme:applied element:microtheme:removed', _.bind(this._onMicroThemeChanged, this));
        },

        _onMicroThemeChanged: function(e) {
            this.$elSlider.slider('option', 'range', statics.getRangeValue(this.$el));
        },

        onDestroy: function() {
            if (this.$elSlider && this.$elSlider.length) {
                this.$elSlider.slider("destroy");
            }
        },

        setFocus: function() {
            var $field = this.$el.closest(constants.inputs.formFieldSelector);
            if ($field.length) {
                $field.attr('tabindex', 0);
                $field.focus();
                $field.removeAttr('tabindex');
            }

            this.$el.find(constants.sliderHandleSelector).focus();
        },

        getValue: function() {
            return this.$elSlider.slider('option', 'value');
        },

        onSetValue: function(value) {
            this.$elSlider.slider('option', 'value', value);
        },

        onValidateValue: function(value) {
            if (_.isString(value)) {
                // remove commas then try to parse as float
                value = parseFloat(value.replace(/,/g, ''));
                if (isNaN(value)) {
                    return false;
                }
            }

            if (value < (this.numberMin || 0) ||
                value > (this.numberMax || 0)) {
                return false;
            }

            return true;
        },

        _onSliderCreated: function(e, ui) {
            this._setInitialValue(this.defaultValue);
        },

        _onSliderChange: function(e, ui) {
            // The values could differ if the step doesn't allow the current value
            if (ui.value !== this.getValue()) {
                this.setValue(ui.value);
            }

            this._updateValueDisplay(ui.value);
            this._positionValueDisplay();
            this.onInputChanged();
        },

        _onSliderSlide: function(e, ui) {
            this._updateValueDisplay(ui.value);
            this._positionValueDisplay();

            var ee = {
                value: ui.value
            };
            this.triggerExtensibility(constants.extensibility.events.valueChanged, ee);
        },

        _setInitialValue: function(defaultValue) {
            var value;
            switch (this.defaultValueType) {
                case 'none':
                    value = this.numberMin;
                    break;

                case 'datafield':
                    if (!this.inStudio) {
                        if (this.dataContext.hasValue) {
                            defaultValue = this.dataContext.value;
                        } else if (this.dataContext.hasDefaultValue) {
                            defaultValue = this.dataContext.defaultValue;
                        }
                    }

                    value = Math.min(this.numberMax, Math.max(this.numberMin, statics.coerceToFloat(defaultValue, this.numberMin)));
                    break;

                case 'custom':
                    value = Math.min(this.numberMax, Math.max(this.numberMin, statics.coerceToFloat(defaultValue, this.numberMin)));
                    break;
            }

            this.setValue(value);

            this.validate(value);
            this._setValueDisplayLocation(this.valueDisplayLocation);
        },

        _updateValueDisplay: function(value) {
            if (value == null) {
                value = this.getValue();
            }

            var ee = {
                value: value,
                prefix: this.valuePrefix,
                suffix: this.valueSuffix
            };
            this.triggerExtensibility(constants.extensibility.events.displayValueChanging, ee);

            this.$elSliderValue.html(ee.value || 0);

            if (ee.prefix) {
                this.$elSliderValue.prepend(ee.prefix);
            }
            if (ee.suffix) {
                this.$elSliderValue.append(ee.suffix);
            }
        },

        _setValueDisplayLocation: function(valueDisplayLocation) {
            this.valueDisplayLocation = valueDisplayLocation;

            this._updateValueDisplay();

            // remove classes first -- necessary for live updating
            var classesToRemove = {};
            this.$.extend(classesToRemove, constants.css.orientation, constants.css.valueLocation);

            for (var c in classesToRemove) {
                if (classesToRemove.hasOwnProperty(c)) {
                    this.$el.removeClass(classesToRemove[c]);
                }
            }

            // the display value location is controlled by these 2 classes:
            this.$el
                .addClass(constants.css.orientation[this.orientation])
                .addClass(constants.css.valueLocation[this.valueDisplayLocation]);

            this._positionValueDisplay();
        },

        _positionValueDisplay: function() {
            switch (this.valueDisplayLocation) {
                case 'handle': {
                    // The defer is so that the handle is aligned properly
                    _.defer(function(me) {
                        var positionCoords = (me.orientation === 'horizontal')
                            ? { my: 'center top', at: 'center bottom' }
                            : { my: 'left center', at: 'right+5 center' };

                        me.$elSliderValue.position(_.extend(positionCoords, {
                            of: me.$el.find(constants.sliderHandleSelector)
                        }));
                    }, this);
                    break;
                }
                case 'above_handle': {
                    // The defer is so that the handle is aligned properly
                    _.defer(function(me) {
                        var positionCoords = (me.orientation === 'horizontal')
                            ? { my: 'center top', at: 'center top' }
                            : { my: 'left center', at: 'left-30 center' };

                        me.$elSliderValue.position(_.extend(positionCoords, {
                            of: me.$el.find(constants.sliderHandleSelector)
                        }));
                    }, this);
                    break;
                }
                default: {
                    this.$elSliderValue.css({
                        position: '',
                        top: '',
                        left: ''
                    });
                }
            }
        },

        studioInitialize: function(options) {
            this.deactivateEvents(this.$elSlider);
            this.deactivateEvents(this.$elSlider.find(constants.sliderHandleSelector));
            if (!Modernizr.pointerevents) {
                this.$elSlider.slider('disable');
            }
        },

        getParamMapOverrides: function() {
            return {
                defaultValue: function(val) {
                    this.defaultValue = val;
                    this._setInitialValue(this.defaultValue);
                },

                defaultValueType: function(val) {
                    this.defaultValueType = val;
                    this._setInitialValue(this.defaultValue);
                },

                orientation: function(val) {
                    this.orientation = val;
                    this.$elSlider.slider('option', 'orientation', this.orientation);
                    this._setValueDisplayLocation(this.valueDisplayLocation);
                },

                numberMin: function(val) {
                    var min = parseFloat(val);
                    this.numberMin = isNaN(min) ? '' : min;
                    this.$elSlider.slider('option', 'min', this.numberMin === '' ? 0 : this.numberMin);

                    this._setInitialValue(this.defaultValue);
                },

                numberMax: function(val) {
                    var max = parseFloat(val);
                    this.numberMax = isNaN(max) ? '' : max;
                    this.$elSlider.slider('option', 'max', this.numberMax === '' ? 100 : this.numberMax);

                    this._setInitialValue(this.defaultValue);
                },

                numberStep: function(val) {
                    var step = parseFloat(val);
                    this.numberStep = isNaN(step) ? 0 : step;
                    this.$elSlider.slider('option', 'step', this.numberStep || 1);
                },

                valueDisplayLocation: this._setValueDisplayLocation,

                valuePrefix: function(val) {
                    if (val !== this.valuePrefix) {
                        this.valuePrefix = val;
                        this._updateValueDisplay();
                    }
                },

                valueSuffix: function(val) {
                    if (val !== this.valueSuffix) {
                        this.valueSuffix = val;
                        this._updateValueDisplay();
                    }
                }
            };
        },

        allowedDropTargets: function(origin) {
            if (origin === 'element'){
                return ['ixp-form-field'];
            }
            return ['ixp-form', 'ixp-form-field'];
        },

        onGetCssClassesToPreserve: function() {
            return statics.cssClassesToPreserve;
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getScaffolding(scaffoldingKey, builder, options);
        }
    });
})(window.ixp.runtime);
